import { Link } from 'react-router-dom';
import { seoArticles } from '@/mocks/articles';

export default function SeoContentSection() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-600 bg-accent-100/80 px-3 py-1.5 rounded-full mb-6">
            SEO Content Hub
          </span>

          <h2 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-950 leading-tight mb-4">
            CSSBuy Spreadsheet:<br />O Guia Definitivo
          </h2>

          <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            Tudo o que precisa de saber sobre o CSSBuy Spreadsheet — a ferramenta número um para organizar compras internacionais da China. Descubra tutoriais, comparações com outros agentes, dicas de economia e muito mais no nosso hub de conteúdo SEO otimizado.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {seoArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer overflow-hidden hover:-translate-y-1"
            >
              <div className="h-40 md:h-44 lg:h-48 overflow-hidden bg-background-200">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 md:p-5 flex-1 flex flex-col">
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 line-clamp-2 mb-3 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-xs font-medium text-accent-600">
                  <span>Ler artigo</span>
                  <i className="ri-arrow-right-line w-3 h-3 flex items-center justify-center group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 mt-16 items-start">
          <div className="flex-1">
            <div className="rounded-3xl overflow-hidden h-64 md:h-80 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20showing%20analytics%20spreadsheet%20and%20product%20comparison%20charts%20on%20screen%2C%20minimal%20clean%20desk%20with%20coffee%20cup%20and%20small%20succulent%20plant%2C%20warm%20natural%20lighting%20from%20window%2C%20cream%20and%20beige%20aesthetic%2C%20organized%20professional%20environment%2C%20editorial%20photography&width=800&height=600&seq=seo-v2-deco-01&orientation=landscape"
                alt="CSSBuy Spreadsheet workspace"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="flex-1 flex flex-col gap-4">
            <div className="rounded-3xl overflow-hidden h-40 md:h-48 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20product%20comparison%20display%20with%20three%20shopping%20packages%20in%20different%20warm%20neutral%20tones%20on%20minimal%20marble%20surface%2C%20warm%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20modern%20fashion%20editorial%20style%2C%20harmonious%20composition%20with%20organic%20shadows&width=800&height=400&seq=seo-v2-deco-02&orientation=landscape"
                alt="Comparação de agentes"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="rounded-3xl overflow-hidden h-40 md:h-48 bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=International%20shipping%20concept%20with%20small%20cardboard%20box%20and%20world%20map%20on%20minimal%20desk%2C%20warm%20golden%20hour%20lighting%2C%20global%20ecommerce%20theme%2C%20clean%20organized%20workspace%2C%20logistics%20and%20delivery%20aesthetic%2C%20professional%20editorial%20photography&width=800&height=400&seq=seo-v2-deco-03&orientation=landscape"
                alt="Shipping internacional"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}